import React, { ReactNode } from "react";

function CommonLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative pt-2 px-[5px] pb-[5px] md:px-[10px] [&>p]:text-slate-500 [&>p]:text-sm [&>p]:italic [&>p]:font-semibold [&>p]:leading-[140%] [&>p]:capitalize [&>p]:mb-1.5 [&>p]:hidden [&>p]:md:block">
      {children}
    </div>
  );
}

export default CommonLayout;
